import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal, output, OutputEmitterRef } from '@angular/core';
import { ButtonComponent } from '@libs/common/components';
import { QuantityCounterAdapterComponent } from '@libs/form/components';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-add-to-cart-small-element',
  imports: [
    ButtonComponent,
    IconComponent,
    QuantityCounterAdapterComponent,
  ],
  templateUrl: './add-to-cart-small-element.component.html',
  styleUrl: './add-to-cart-small-element.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToCartSmallElementComponent {
  public amount: ModelSignal<number> = model.required();
  public isInCart: InputSignal<boolean> = input.required();
  public loading: InputSignal<boolean> = input(false);
  public disabled: InputSignal<boolean> = input(false);
  public add: OutputEmitterRef<void> = output();
  public remove: OutputEmitterRef<void> = output();
  public quantityChangeDebounceMs: InputSignal<number> = input(800);
  public quantityMax: InputSignal<number | undefined> = input();
  public quantityMin: InputSignal<number | undefined> = input();

}
